import { useTheme } from '@mui/material';

export const FilterIcon = () => {
    const theme = useTheme();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                d="M7 12.8652C7 11.077 8.45195 9.625 10.2402 9.625H45.7516C47.548 9.625 49 11.077 49 12.8652C49 13.6199 48.7375 14.35 48.2535 14.9324L33.25 33.0695V43.6023C33.25 45.1363 32.0031 46.3832 30.4691 46.3832C29.8539 46.3832 29.2551 46.1781 28.7629 45.8008L23.759 41.9125C23.1191 41.4121 22.7418 40.6492 22.7418 39.8371V33.0777L7.74648 14.9324C7.2625 14.35 7 13.6199 7 12.8652ZM10.2402 12.25C9.8957 12.25 9.625 12.5289 9.625 12.8652C9.625 13.0129 9.67422 13.1441 9.76445 13.259L25.0715 31.757C25.2684 31.9949 25.375 32.2902 25.375 32.5938V39.8289L30.3789 43.7172C30.4035 43.7418 30.4363 43.75 30.4691 43.75C30.5512 43.75 30.625 43.6844 30.625 43.5941V32.5938C30.625 32.2902 30.7316 31.9949 30.9285 31.757L46.2355 13.259C46.3258 13.1523 46.375 13.0129 46.375 12.8652C46.375 12.5207 46.0961 12.25 45.7598 12.25H10.2402Z"
                fill={theme.colors.other.icon.stroke.tertiary}
            />
        </svg>
    );
};
